import React, {useState, useRef, useEffect} from 'react';
import useBlogs from '../../hooks/useBlogsEcoAlliance';
import EcoAllianceBlogModal from './EcoAllianceBlogModal/EcoAllianceBlogModal';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as rightArrow } from '../../../images/left-arrow.svg';
import { default as EcoAllianceBlog } from '../../../images/Eco_Alliance_Default_blog.svg';
import './EcoAllianceReel.scss';

const EcoAllianceReel = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const blogsList = useBlogs();
  const EcoAllianceReelRef = useRef();
  const {edges} = blogsList?.posts;
  const blogs = [...edges.splice(0, 50)];
  let scrollAmount = 0;
  const DefaultBlogSelection = {
    "node": {
        "id": "default blog selection",
        "feature_image": EcoAllianceBlog,
        "excerpt": "Welcome to the Eco Alliance",
        "slug": "default"
    }
  }

  blogs.splice(2, 0, DefaultBlogSelection);

  useEffect(() => {
    if(window.innerWidth < 768) {
      EcoAllianceReelRef?.current?.scrollTo({
        left: scrollAmount += 450,
        behavior: 'smooth'
      })
    }
  }, []);

  const onBlogClick = (item) => {
    if(item?.node?.slug !== "default") {
      setSelectedBlog(item);
      setIsOpen(true);
    }
  }

  const scrollToRight = () => {
    EcoAllianceReelRef.current.scrollTo({
      left: scrollAmount += 800,
      behavior: 'smooth'
    });
  }

  const scrollToLeft = () => {
    EcoAllianceReelRef.current.scrollTo({
      left: scrollAmount -= 800,
      behavior: 'smooth'
    });
  }

  return (
    <>
      <div className="noissue__eco-alliance__reel-section">
        <div className="noissue__eco-alliance__reel-section__details">
          <div className="noissue__eco-alliance__reel-section__details__heading"> Being Better Together </div>
          <div className="noissue__eco-alliance__reel-section__details__subheading"> See what our alliance members get up to... </div>
        </div>
        {
          blogs.length > 4 && 
          <div className="upcoming-event-list-arrow-buttons">
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions*/}
            <CommunityImg
              className="left-arrow"
              onClick={() => scrollToLeft()}
              onKeyDown={() => scrollToLeft()}
              src={rightArrow}
              alt="left arrow"
            />
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions*/}
            <CommunityImg
              className="right-arrow"
              onClick={() => scrollToRight()}
              onKeyDown={() => scrollToRight()}
              src={rightArrow}
              alt="right arrow"
            />
          </div>
        }
        <div  className="noissue__eco-alliance__reel-section__blogs" ref={EcoAllianceReelRef}>
          {
            blogs.map((blog, idx) => {
              return <div key={`blog-${idx}`} 
                className={`noissue__eco-alliance__reel-section__blogs__item ${blog?.node?.slug == "default" ? 'default-blog' : '' }`}>
                <CommunityImg 
                  onKeyDown={()=>onBlogClick(blog)} 
                  onClick={()=>onBlogClick(blog)} 
                  role="presentation"
                  src={blog.node.feature_image} 
                  alt={blog.node.slug} />
                <span className="blogs__item__excerpt">
                  {blog.node.excerpt}
                </span>
              </div>
            })
          }
        </div>
      </div>
      {
        isOpen && <EcoAllianceBlogModal blogList={edges} blog={selectedBlog} isOpen={isOpen} onClose={()=>setIsOpen(false)} />
      }
    </>
  )
}

export default EcoAllianceReel;